import Model from "../_model";

export default class PackagingModel extends Model {
	constructor(provider) {
		super(provider, "packagings");
	}
	filter(companyId, { onSuccess, onFail } = {}) {
		return super.filter({ params: { companyId }, onSuccess, onFail });
	}
	find(id, { onSuccess, onFail } = {}) {
		return super.find({ id, onSuccess, onFail });
	}
	create(companyId, packaging, { onSuccess, onFail } = {}) {
		const body = { companyId, name: packaging.name };
		return super.create(body, { onSuccess, onFail });
	}
	update(companyId, packaging, { onSuccess, onFail } = {}) {
		const id = packaging.id || packaging._id;
		const body = { companyId, name: packaging.name };
		return super.update(body, { id, onSuccess, onFail });
	}
	delete(companyId, id, { onSuccess, onFail } = {}) {
		return super.delete({ id, onSuccess, onFail });
	}
}
